var WindscreenComponent = require("./components/windscreen/windscreen.component");
// var AccessibilityWidgetComponent = require("./components/accessibility-widget.component");
var NotificationService = require("./components/notification-pane/notification-panes.service");
var CookiesService = require("./services/cookies.service");

function PcgFrontend() {
    this.init = function () {
        $.pcg = $.pcg || {};
        $.pcg.frontend = $.pcg.frontend || {};

        $.extend($.pcg.frontend, {
            windscreen: new WindscreenComponent(),
            // accessibilityWidget: new AccessibilityWidgetComponent(),
            notificationService: new NotificationService(),
            cookieService: CookiesService
        });
    };
}

module.exports = new PcgFrontend();
